// Las fichas de referencia de una card (miniatura + rótulo), las mismas en la card de
// imagen y en la de video (ADR-2026-09-25-las-referencias-se-ven-en-la-card). Sólo
// lectura: se cambian pidiéndoselo al agente por chat.
import React from 'react';
import CachedImg from '../../../components/CachedImg';
import type { FichaDeReferencia } from '../miniaturasDeReferencias';

export const ChipsDeReferencias: React.FC<{ fichas: FichaDeReferencia[] }> = ({ fichas }) => (
  <div className="flex flex-wrap gap-1.5">
    {fichas.map((c, i) => (
      <span key={i} className="flex items-center gap-1.5 bg-[#F7F7F9] rounded-full pr-3 pl-1 py-0.5">
        {c.thumb ? (
          <CachedImg src={c.thumb} alt={c.label} className="w-5 h-5 rounded-full object-cover" />
        ) : (
          <span className="w-5 h-5 rounded-full bg-black/[0.06]" aria-hidden="true" />
        )}
        <span className="text-[12.5px] font-medium text-brand-black/85 truncate max-w-[160px]">{c.label}</span>
      </span>
    ))}
  </div>
);
